import React, { useState, useEffect } from 'react';
import { Observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import {
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Tooltip,
} from '@material-ui/core';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { toJS } from 'mobx';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, StandardBox } from '../../styles/styles';
import { safeEval } from '../../util/UtilFunctions';
import OrgUserInfo from '../OrgUserInfo';

const OrgUsers = ({ roles }) => {
  const { orgStore } = useRootStore();
  const filteredRoles = roles.filter(role => !role.IsOwner);

  return (
    <Observer
      render={() => {
        const { state, orgUserArray } = orgStore;
        if (!state || state === 'error')
          return <Redirect to="/select-organization" />;
        return (
          <FlexDiv>
            <StandardBox>
              <Typography variant="h4" gutterBottom>
                Users
              </Typography>

              <List>
                {orgUserArray.map((user, i) => {
                  const { OrgRoles, UserId, Email, UserName } = user;
                  return (
                    <ListItem key={UserId} divider>
                      <ListItemText
                        primary={UserName || Email}
                        secondary={OrgRoles.map((number, index) => (
                          <span key={number}>
                            {safeEval(
                              () =>
                                roles.find(r => r.OrgRoleId === number).Name,
                              null,
                            )}
                            {OrgRoles.length > 1 &&
                            index !== OrgRoles.length - 1
                              ? ', '
                              : ''}
                          </span>
                        ))}
                      />
                      <ListItemSecondaryAction>
                        <OrgUserInfo user={user} roles={filteredRoles}>
                          {({ handleClickOpen }) => {
                            return (
                              <Tooltip title="Manage User" placement="right">
                                <IconButton
                                  edge="end"
                                  aria-label="edit account"
                                  onClick={() => handleClickOpen()}
                                >
                                  <AccountBoxIcon />
                                </IconButton>
                              </Tooltip>
                            );
                          }}
                        </OrgUserInfo>
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </StandardBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default OrgUsers;
